import React, { useState } from "react";
import { BsSend } from "react-icons/bs";
import axios from "axios";
import { CONTACT_API } from "./../../assets/data/api";
import { contact_inputs } from "./../../assets/data/inputs";
import { useStateContext } from "./../../context/";
import { gradient_primary, navy } from "./../../assets/data/colors"

// email us component
const EmailUs = () => {
    const { is_loged, set_alert, is_disable, set_is_disable } = useStateContext();
    const init_state = {
        email: is_loged ? is_loged.mail : "",
        subject: "",
        message: "",
    };
    const [state, set_state] = useState(init_state);

    // send the message to the database
    const submit_handler = (event) => {
        event.preventDefault();
        set_is_disable(true);
        const endpoint = CONTACT_API + "create.php";
        const username = is_loged ? is_loged.username : "demo";
        const data = { ...state, username };
        axios.post(endpoint, data).then((response) => {
            const { data } = response;
            if (data.success) {
                set_state(init_state);
                set_alert({ type: "success", text: "Message sent successfully" });
            } else if (data.error) set_alert({ type: "error", text: data.error });
            set_is_disable(false);
        });
    };

    // the input handler
    const state_handler = (event) =>
        set_state((prev) => ({ ...prev, [event.target.name]: event.target.value }));

    return (
        <div className="w-full">
            <div className="mb-6">
                <p style={{color: navy}} className="text-xs font-semibold tracking-[2.5px] uppercase mb-1">Direct Message</p>
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Send us a message</h3>
                <p className="text-sm text-gray-400 font-light mt-1">We'll get back to you within 24 hours.</p>
            </div>

            <form onSubmit={submit_handler} className="space-y-4">
                {contact_inputs.map((item) =>
                    item.type === "text" ? (
                        <div key={item.name} className="group">
                            <label htmlFor={item.name} className="block text-xs font-semibold tracking-wider uppercase text-gray-400 dark:text-gray-500 mb-2">
                                {item.name}
                            </label>
                            <input
                                type="text"
                                name={item.name}
                                id={item.name}
                                placeholder={item.placeholder}
                                value={state[item.value]}
                                onChange={state_handler}
                                required
                                className={`w-full px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-900 dark:text-white text-sm font-light placeholder-gray-300 dark:placeholder-gray-600 focus:outline-none focus:border-navy dark:focus:border-navy focus:bg-white dark:focus:bg-gray-800 transition-all duration-200`}
                            />
                        </div>
                    ) : (
                        <div key={item.name}>
                            <label htmlFor={item.name} className="block text-xs font-semibold tracking-wider uppercase text-gray-400 dark:text-gray-500 mb-2">
                                {item.name}
                            </label>
                            <textarea
                                id={item.name}
                                name={item.name}
                                rows="5"
                                placeholder={item.placeholder}
                                value={state[item.value]}
                                onChange={state_handler}
                                required
                                className={`w-full px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-900 dark:text-white text-sm font-light placeholder-gray-300 dark:placeholder-gray-600 focus:outline-none focus:border-navy dark:focus:border-navy focus:bg-white dark:focus:bg-gray-800 transition-all duration-200 resize-none`}
                            />
                        </div>
                    )
                )}

                <div className="pt-2">
                    <button type="submit" disabled={is_disable} className="transition-opacity duration-100 hover:opacity-90 flex items-center gap-2 px-6 py-3 rounded-xl text-md font-medium text-white disabled:opacity-50 disabled:cursor-not-allowed" style={{ background: gradient_primary }}>
                        <BsSend size={18} />
                        Send Message
                    </button>
                </div>
            </form>
        </div>
    );
};
export default EmailUs;